import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface MasConfirmDialogData {
  title?: string;
  message?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** 'destructive' shows a red icon tile and a red confirm button (e.g. logout, delete). */
  variant?: 'default' | 'destructive';
}

@Component({
  selector: 'app-mas-confirm-dialog',
  template: `
    <div class="cd">
      <div class="cd-icon-tile" *ngIf="data?.variant === 'destructive'">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
          <polyline points="16 17 21 12 16 7" />
          <line x1="21" x2="9" y1="12" y2="12" />
        </svg>
      </div>
      <h3 class="cd-title">{{ data?.title || 'Are you sure?' }}</h3>
      <p class="cd-msg" *ngIf="data?.message">{{ data?.message }}</p>
      <div class="cd-actions">
        <button type="button" class="cd-btn cd-cancel" (click)="ref.close(false)">
          {{ data?.cancelLabel || 'Cancel' }}
        </button>
        <button type="button" class="cd-btn"
          [class.cd-confirm]="data?.variant !== 'destructive'"
          [class.cd-confirm-destructive]="data?.variant === 'destructive'"
          (click)="ref.close(true)">
          {{ data?.confirmLabel || 'Confirm' }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .cd {
        padding: 20px;
        font-family: var(--primary-font-family, 'DM Sans', sans-serif) !important;
      }
      .cd-icon-tile {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: #fdecec;
        color: #c22b2b;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 12px;
      }
      .cd-title {
        margin: 0 0 8px;
        font-size: 15px;
        font-weight: 600;
        color: #1f2937;
        font-family: var(--primary-font-family, 'DM Sans', sans-serif) !important;
      }
      .cd-msg {
        margin: 0 0 18px;
        font-size: 13px;
        line-height: 1.5;
        color: #6b7280;
      }
      .cd-actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
      }
      .cd-btn {
        padding: 8px 16px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        border: 1px solid transparent;
        outline: none;
        transition: background 0.15s, border-color 0.15s;
      }
      .cd-cancel {
        background: transparent;
        border-color: #d1d5db;
        color: #374151;
      }
      .cd-cancel:hover {
        background: #f3f4f6;
      }
      .cd-confirm {
        background: var(--primary-bg-color, #3a0044);
        color: #ffffff;
      }
      .cd-confirm:hover {
        opacity: 0.9;
      }
      .cd-confirm-destructive {
        background: #c22b2b;
        color: #ffffff;
      }
      .cd-confirm-destructive:hover {
        opacity: 0.9;
      }
    `,
  ],
})
export class ConfirmDialogComponent {
  constructor(
    public ref: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MasConfirmDialogData,
  ) {}
}
